import vueGtmMin from 'vue-gtm'
import vueMultianalyticsMin from 'vue-multianalytics'
import router from '../router'

const analyticsPlugin = {
  install: Vue => {
    function initializeAnalytics() {
      let mixpanelConfig = {
        token: process.env.VUE_APP_MIXPANEL_HSCODE
      }
      Vue.use(vueMultianalyticsMin, {
        modules: {
          mixpanel: mixpanelConfig
        }
      })

      Vue.use(vueGtmMin, {
        id: process.env.VUE_APP_GTM_HSCODE, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
        debug: true, // Whether or not display console logs debugs (optional)
        loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
        vueRouter: router // Pass the router instance to automatically sync with router (optional)
      })

      router.afterEach(to => {
        Vue.nextTick(() => {
          Vue.ma.trackView({ viewName: to.meta.analytics || to.fullPath })
        })
      })
    }

    // Inject the consent manager functions into the Vue prototype.
    Vue.prototype.$analytics = { initializeAnalytics }
  }
}

export default analyticsPlugin
